import React, { useState } from 'react';
import { Card, Statistic, Skeleton } from 'antd';
import type { ReactNode } from 'react';

interface SummaryCardProps {
  title: string;
  value: number | string;
  icon: ReactNode;
  cardKey: string;
}

interface SummaryCardsProps {
  cards: SummaryCardProps[];
  loading: boolean;
}

type HoveredCard = string | null;

const SummaryCard: React.FC<SummaryCardsProps> = ({ cards, loading }) => {
  const [hoveredCard, setHoveredCard] = useState<HoveredCard>(null);

  const cardStyle = (cardName: string) => ({
    backgroundColor: '#f0f5ff',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    transform: hoveredCard === cardName ? 'translateY(-5px)' : 'none',
    boxShadow: hoveredCard === cardName ? '0 4px 12px rgba(0, 0, 0, 0.1)' : 'none',
    minWidth: 220,
    marginRight: 16,
  });

  return (
    <div style={{ marginBottom: 24, overflowX: 'auto' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center', // Center the cards horizontally
          paddingBottom: 8,
          gap: 16,
        }}
      >
        {cards.map(card => (
          <div key={card.cardKey}>
            {loading ? (
              <Skeleton active style={{ minWidth: 220 }} />
            ) : (
              <Card
                style={cardStyle(card.cardKey)}
                onMouseEnter={() => setHoveredCard(card.cardKey)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <Statistic
                  title={card.title}
                  value={card.value}
                  prefix={card.icon}
                  valueStyle={{ color: 'var(--color-primary)' }}
                />
              </Card>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummaryCard;